import { type Project, projectsApi } from '@/api/projects';
import { useAuthStore } from '@/stores/auth';
import { useQuery } from '@tanstack/react-query';

// Re-export so existing imports `import type { Project } from '@/hooks/use-projects'`
// keep working.
export type { Project };

export function useProjects() {
  const access = useAuthStore((s) => s.access);
  return useQuery({
    queryKey: ['projects'],
    queryFn: () => projectsApi.list().then((r) => r.items),
    enabled: !!access,
    staleTime: 60_000,
  });
}
